// extracted by mini-css-extract-plugin
export default {"content":"Tooltip_content__MIi2H","tooltip-fade-in":"Tooltip_tooltip-fade-in__pLh99","tooltip-fade-out":"Tooltip_tooltip-fade-out__4KOfZ","arrow":"Tooltip_arrow__ey-A4"};